import ContentBody from '@op/components/ContentBody';
import {
  ReportPermissionProvider,
  parseReportOwnerQuery,
} from '@op/components/ReportPermission';
import useLanguage from '@op/hooks/useLanguage';
import React, { useCallback, useMemo, useState } from 'react';
import { Layout, TabPanel, Tabs } from 'tea-component';
import { connect, useLocation } from 'umi';
import SavedAnalysisList from './pages/SavedAnalysisList';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { TopicAnalysis, TopicAnalysisList } from '@op/operationLog/pages';
import useTabHistory from '@op/hooks/useTabHistory';
import { PAGE_NAME } from '@op/constants/page';
import './scss/page.scss';
import KeywordCardAnalysis from './pages/KeywordCardAnalysis';

const { Content } = Layout;
interface IKeywordAndURLDrill {
  gameInfo: any;
  filter: any;
  wholeGameInfo: any;
  userInfo: any;
}

const KeywordAndURLDrill = ({
  gameInfo,
  wholeGameInfo,
  userInfo,
}: IKeywordAndURLDrill) => {
  const { formatMessage } = useLanguage();
  const location = useLocation<{ query?: { owner?: string } }>();
  const initialOwner = useMemo(
    () => parseReportOwnerQuery(location?.query?.owner),
    [location?.query?.owner],
  );
  const { tab: activeId, onActive } = useTabHistory({
    defaultValue: 'createAnalysis',
  });

  // 用于存储从 KeywordFilter 传递的 secondSegment
  const [initialSecondSegment, setInitialSecondSegment] = useState<
    string | undefined
  >();

  // 切换到 savedAnalysisList tab，并设置 secondSegment
  const handleChangeTab = useCallback(
    (secondSegment?: string) => {
      setInitialSecondSegment(secondSegment);
      onActive({ id: 'savedAnalysisList' });
    },
    [onActive],
  );

  useInitBuriedPointInfo({
    buriedPoint:
      activeId === 'savedAnalysisList' ? TopicAnalysisList : TopicAnalysis,
  });

  const tabs = useMemo(
    () => [
      {
        id: 'createAnalysis',
        label: formatMessage({
          id: 'Create Analysis',
        }),
      },
      {
        id: 'savedAnalysisList',
        label: formatMessage({
          id: 'Saved Analysis List',
        }),
      },
    ],
    [formatMessage],
  );

  return (
    <ReportPermissionProvider
      notificationMode={activeId === 'savedAnalysisList' ? 'list' : 'create'}
    >
      <Content className="dbo-page dbo-page-keyword-url-drill">
        <ContentBody
          pageName={PAGE_NAME.AI_TOPIC_ANALYSIS}
          contentHeard={
            <Content.Header
              className="dbo-header  contentHead-normal"
              title={formatMessage({ id: PAGE_NAME.AI_TOPIC_ANALYSIS })}
            >
              <div className="header-tab">
                <Tabs
                  ceiling
                  tabs={tabs}
                  animated={false}
                  activeId={activeId}
                  onActive={onActive}
                />
              </div>
            </Content.Header>
          }
        >
          <Tabs
            ceiling
            tabs={tabs}
            className="dbo-hide-tabs dbo-header-tab"
            animated={false}
            destroyInactiveTabPanel={false}
            activeId={activeId}
            onActive={onActive}
          >
            <TabPanel id="createAnalysis">
              <KeywordCardAnalysis
                gameInfo={gameInfo}
                userInfo={userInfo}
                wholeGameInfo={wholeGameInfo}
                changeTab={handleChangeTab}
                isTopicAnalysis
              ></KeywordCardAnalysis>
            </TabPanel>
            <TabPanel id="savedAnalysisList">
              <SavedAnalysisList
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
                needRequest={activeId === 'savedAnalysisList'}
                categoryType="keyword_topic"
                showSegment
                initialSecondSegment={initialSecondSegment}
                initialOwner={initialOwner}
              ></SavedAnalysisList>
            </TabPanel>
          </Tabs>
        </ContentBody>
      </Content>
    </ReportPermissionProvider>
  );
};

export default connect((state: any) => {
  const { opinionCommon, opinionFilter, home } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(KeywordAndURLDrill);
